import React, { Fragment, useState, useEffect } from "react";

import PlayGamesGoal      from "./Items/PlayGames";
import SpinTheWheelGoal   from "./Items/SpinTheWheel";
import PlayBetGoal        from "./Items/PlayBet";
import CompleteOfferGoal  from "./Items/CompleteOffer";
import CompleteSurveyGoal from "./Items/CompleteSurvey";
import DailyCheckinsGoal  from './Items/DailyCheckins';
import PlayDragonHitGoal  from './Items/PlayDragonHit';

import Loader from "~/components/loader"
import User from "~/services/user";


const DailyGoals = ({})=> {

  const [dailyGoals, setDailyGoals] = useState();
  const [user      , setUser      ] = useState();
  const [loading   , setLoading   ] = useState(true);

  useEffect(()=> {
    (async ()=> {
      setDailyGoals(await User.getDailyGoals());
      setUser(await User.account());
      setLoading(false);
    })();
  }, []);

  if(!loading && !dailyGoals) return null;
  if(loading) return ( <Loader type={19} center className="m-b-20" /> );

  return (
    <Fragment>
      <h1 className="main-title"> Daily Goals </h1>

      <DailyCheckinsGoal  status={dailyGoals.dailyCheckinsGoal} />
      <PlayDragonHitGoal  status={dailyGoals.playedDragonHitGoal} />
      <PlayGamesGoal      status={dailyGoals.playedGameGoal} />
      <SpinTheWheelGoal   status={dailyGoals.spinnedWheelGoal} />
      <PlayBetGoal        status={dailyGoals.completedBetGoal} user={user} />
      <CompleteOfferGoal  status={dailyGoals.completedOfferGoal} />
      <CompleteSurveyGoal status={dailyGoals.completedSurveyGoal} />
    </Fragment>
  );
}

export default DailyGoals;
